import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="sticky top-0 w-full z-50 bg-white shadow-sm">
      <div className="max-w-content mx-auto px-6 h-[70px] flex items-center justify-between">
        <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img
            className="w-[210px] h-[34px] object-cover"
            src={require('../assets/img/navbar/logo.png')}
            alt="Metalogix Logo"
          />
        </Link>

        {/* Hamburger button — mobile only */}
        <button
          className="lg:hidden flex flex-col justify-center gap-1.5 w-8 h-8"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block h-0.5 w-full bg-ebony-clay transition-transform ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block h-0.5 w-full bg-ebony-clay transition-opacity ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block h-0.5 w-full bg-ebony-clay transition-transform ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>

        {/* Desktop nav links */}
        <div className="hidden lg:flex items-center gap-8">
          <Link
            to="/about"
            className={`whitespace-nowrap tracking-[0.8px] leading-normal font-proxima-bold font-bold text-base transition-colors ${
              isActive('/about') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            About
          </Link>
          <Link
            to="/services"
            className={`whitespace-nowrap tracking-[0.8px] leading-normal font-proxima-bold font-bold text-base transition-colors ${
              isActive('/services') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            Services
          </Link>
          <Link
            to="/faq"
            className={`whitespace-nowrap tracking-[0.8px] leading-normal font-proxima-bold font-bold text-base transition-colors ${
              isActive('/faq') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            FAQ
          </Link>
          <Link
            to="/contact"
            className={`whitespace-nowrap tracking-[0.8px] leading-normal font-proxima-bold font-bold text-base transition-colors ${
              isActive('/contact') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            Contact
          </Link>
          <a href="#get-started" className="inline-flex items-center justify-center rounded-md overflow-hidden bg-royal-blue cursor-pointer py-3 px-6 hover:bg-opacity-90 transition-colors">
            <span className="font-proxima-bold font-bold text-white text-lg leading-6 tracking-normal whitespace-nowrap">
              GET STARTED
            </span>
          </a>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          <Link
            to="/about"
            className={`tracking-[0.8px] font-proxima-bold font-bold text-base transition-colors ${
              isActive('/about') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            About
          </Link>
          <Link
            to="/services"
            className={`tracking-[0.8px] font-proxima-bold font-bold text-base transition-colors ${
              isActive('/services') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            Services
          </Link>
          <Link
            to="/faq"
            className={`tracking-[0.8px] font-proxima-bold font-bold text-base transition-colors ${
              isActive('/faq') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            FAQ
          </Link>
          <Link
            to="/contact"
            className={`tracking-[0.8px] font-proxima-bold font-bold text-base transition-colors ${
              isActive('/contact') ? 'text-royal-blue' : 'text-ebony-clay hover:text-royal-blue'
            }`}
          >
            Contact
          </Link>
          <a href="#get-started" className="inline-flex items-center justify-center rounded-md bg-royal-blue py-3 px-6">
            <span className="font-proxima-bold font-bold text-white text-lg leading-6">
              GET STARTED
            </span>
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
